import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { getInsuranceOfferRequestsDetails } from "./modules/actions";
import { downloadFile } from "../../OfferRequests/modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    requestDetails: state.insuranceRequestDetailsReducer.requestDetails,
    isSent: state.insuranceRequestDetailsReducer.isSent,
    loggedUser: state.authReducer.loggedUser,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      getInsuranceOfferRequestsDetails,
      downloadFile,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
